<template>
    <div class="RecoActionButtons">
        <el-button-group>
            <el-button type="primary" size="mini" class="actionBtns left-action-btn" v-on:click="goToLink(secondActionBtnLink, 'shortTerm')" :class="{'activeBtn': activeButton == 'shortTerm'}">Short Term</el-button>
            <el-button type="primary" size="mini" class="actionBtns right-action-btn" v-on:click="goToLink(firstActionBtnLink, 'longTerm')" :class="{'activeBtn': activeButton == 'longTerm'}">Long Term</el-button>
        </el-button-group>
    </div>
</template>
<script>
import {EventBus} from '../eventBus';
export default {
    name: 'RecoActionButtons',
    props: ['activeBtn', 'firstBtnLink', 'secondBtnLink'],
    data(){
        return{
            activeButton: this.activeBtn,
            firstActionBtnLink: this.firstBtnLink,
            secondActionBtnLink: this.secondBtnLink
        }
    },
    methods: {
        goToLink(link, reco){
            this.activeButton = reco;
            
            setTimeout(()=>{
                this.$router.push(link);
            },100)

            this.$store.commit('commitActiveTerm', this.activeButton);
        },
    },
    beforeDestroy(){
        EventBus.$off();
    },
}
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.actionBtns{
  background-color: transparent;
  border: 1px solid $primary-theme-color;
  color: $primary-theme-color;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}
.activeBtn{
    background-color: $primary-theme-color;
    border-color: $primary-theme-color;
    color: #fff;
    text-transform: uppercase;
}
.RecoActionButtons .left-action-btn{
    border-bottom-left-radius: 25px;
    border-top-left-radius: 25px;
}
.RecoActionButtons .right-action-btn{
    border-bottom-right-radius: 25px;
    border-top-right-radius: 25px;
}
</style>
<style>
.RecoActionButtons .el-button-group {
    display: flex;
    vertical-align: middle;
}
.RecoActionButtons .left-action-btn span{
    font-size: 10px;
}
.RecoActionButtons .right-action-btn span{
    font-size: 10px;
}
</style>
